/**
 * Contract type constants
 * 
 * Note: These constants mirror the backend CONTRACT_TYPES defined in:
 * packages/functions/src/direct/services/enrollment.service.ts
 * 
 * Future refactor: Consider extracting these to a shared package
 * that both frontend and backend can import from to ensure type safety
 * and consistency across the codebase.
 */ export const CONTRACT_TYPES = {
    DIRECT: 'DIRECT',
    AWS_MARKETPLACE: 'AWS_MARKETPLACE',
    TRIAL: 'TRIAL'
};
export const CREATE_CONTRACT_CURRENCIES = {
    USD: 'USD',
    EUR: 'EUR'
};
/**
 * Contract status types
 */ export const CONTRACT_STATUS = {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    PENDING: 'pending'
};
/**
 * Contract type display configuration
 */ export const CONTRACT_TYPE_CONFIG = {
    [CONTRACT_TYPES.DIRECT]: {
        label: 'Direct',
        expiryLabel: 'Expires',
        badgeColor: {
            bg: 'bg-gray-100',
            text: 'text-gray-800'
        },
        autoRenew: false,
        showDaysRemaining: false,
        warningThresholdDays: undefined
    },
    [CONTRACT_TYPES.AWS_MARKETPLACE]: {
        label: 'Marketplace',
        expiryLabel: 'Next Renewal',
        badgeColor: {
            bg: 'bg-blue-100',
            text: 'text-blue-800'
        },
        autoRenew: true,
        showDaysRemaining: false,
        warningThresholdDays: undefined
    },
    [CONTRACT_TYPES.TRIAL]: {
        label: 'Trial',
        expiryLabel: 'Trial Ends',
        badgeColor: {
            bg: 'bg-purple-100',
            text: 'text-purple-800'
        },
        autoRenew: false,
        showDaysRemaining: true,
        warningThresholdDays: 3
    }
};
/**
 * Status badge configuration
 */ export const STATUS_BADGE_CONFIG = {
    [CONTRACT_STATUS.ACTIVE]: {
        label: 'Active',
        color: {
            bg: 'bg-green-100',
            text: 'text-green-800'
        }
    },
    [CONTRACT_STATUS.EXPIRED]: {
        label: 'Expired',
        color: {
            bg: 'bg-red-100',
            text: 'text-red-800'
        }
    },
    [CONTRACT_STATUS.PENDING]: {
        label: 'Pending',
        color: {
            bg: 'bg-yellow-100',
            text: 'text-yellow-800'
        }
    }
};
/**
 * Contract type-specific status badge overrides
 */ export const CONTRACT_TYPE_STATUS_OVERRIDES = {
    [CONTRACT_TYPES.TRIAL]: {
        [CONTRACT_STATUS.ACTIVE]: {
            label: 'Trial Active',
            color: {
                bg: 'bg-yellow-100',
                text: 'text-yellow-800'
            }
        },
        [CONTRACT_STATUS.EXPIRED]: {
            label: 'Trial Ended',
            color: {
                bg: 'bg-red-100',
                text: 'text-red-800'
            }
        }
    },
    [CONTRACT_TYPES.AWS_MARKETPLACE]: {
        [CONTRACT_STATUS.ACTIVE]: {
            label: 'Active (Auto-Renewing)',
            color: {
                bg: 'bg-green-100',
                text: 'text-green-800'
            }
        }
    }
};
